import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { PageHeader, Card, EmptyState } from "@/components/Shell";
import StatusBadge from "@/components/StatusBadge";
import { useAuth } from "@/lib/auth";
import { Send } from "lucide-react";

export default function MyMaterial() {
  const { user } = useAuth();
  const [serials, setSerials] = useState([]);
  const [requests, setRequests] = useState([]);

  useEffect(() => {
    api.get("/stock/serials?status=issued").then(r => setSerials(r.data.filter(s => s.issued_to === user.id)));
    api.get("/requests", { params: { status: "Pending Engineer Usage Update" } }).then(r => setRequests(r.data));
  }, [user.id]);

  return (
    <div className="p-4 md:p-8" data-testid="mymaterial-page">
      <PageHeader title="My Material" subtitle="Items issued to you and pending usage updates." />

      <Card className="p-5 mb-4">
        <div className="font-display font-semibold mb-3">Pending Usage Updates</div>
        {requests.length === 0 ? <EmptyState title="All caught up" desc="No pending usage updates." icon={Send} /> :
          <div className="space-y-2">
            {requests.map(r => (
              <Link key={r.id} to={`/requests/${r.id}`} className="flex items-center justify-between border-b border-zinc-100 pb-2 hover:bg-zinc-50 px-1 rounded">
                <div>
                  <div className="font-semibold text-sm">{r.request_no}</div>
                  <div className="text-xs text-zinc-500">{r.customer_name} · {r.project_id || "No project"}</div>
                </div>
                <StatusBadge status={r.status} />
              </Link>
            ))}
          </div>
        }
      </Card>

      <Card className="p-5">
        <div className="font-display font-semibold mb-3">My Issued Serials</div>
        {serials.length === 0 ? <div className="text-xs text-zinc-500">No serials currently issued to you.</div> :
          <table className="w-full text-sm data-table">
            <thead><tr><th className="text-left">Serial #</th><th className="text-left">Product</th><th className="text-left">Status</th></tr></thead>
            <tbody>
              {serials.map(s => (
                <tr key={s.id} className="border-t border-zinc-100">
                  <td className="num">{s.serial_no}</td>
                  <td className="text-zinc-500 num text-[11px]">{s.product_id}</td>
                  <td>{s.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        }
      </Card>
    </div>
  );
}
